module.exports = __webpack_public_path__ + "img/VL_20_02.9adf5f47.png";